// removed by extract-text-webpack-plugin
module.exports = {"Loader":"Spinner__Loader__-hash--base64-5-","load6":"Spinner__load6__-hash--base64-5-","round":"Spinner__round__-hash--base64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Spinner/Spinner.css
// module id = 100
// module chunks = 0